var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 3.80334C0.25 2.14866 1.59531 0.803345 3.25 0.803345H13.75C15.4047 0.803345 16.75 2.14866 16.75 3.80334V21.8033C16.75 23.458 15.4047 24.8033 13.75 24.8033H3.25C1.59531 24.8033 0.25 23.458 0.25 21.8033V3.80334ZM10 21.8033C10 21.4055 9.84196 21.024 9.56066 20.7427C9.27936 20.4614 8.89782 20.3033 8.5 20.3033C8.10218 20.3033 7.72064 20.4614 7.43934 20.7427C7.15804 21.024 7 21.4055 7 21.8033C7 22.2012 7.15804 22.5827 7.43934 22.864C7.72064 23.1453 8.10218 23.3033 8.5 23.3033C8.89782 23.3033 9.27936 23.1453 9.56066 22.864C9.84196 22.5827 10 22.2012 10 21.8033ZM13.75 3.80334H3.25V18.8033H13.75V3.80334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.14b0910bd54288b1f23406405d2e1967.svg";
export { ForwardRef as ReactComponent };